'use client';

import { selectProduct } from '@castlery/modules-product-domain';
import { useAppSelector } from '@castlery/shared-redux-store';
import LazyLoad from 'react-lazyload';
import { ProductCollection } from './components/product-collection';
import { Box, useBreakpoints } from '@castlery/fortress';

export const ProductRecommendationsClient = () => {
  const product = useAppSelector(selectProduct);
  const { mobile, tablet } = useBreakpoints();
  return (
    <>
      {product && product?.collections?.length > 0 && (
        <LazyLoad
          offset={300}
          once
          placeholder={<Box sx={{ height: mobile ? '470px' : tablet ? '486px' : '592px' }} />}
        >
          <ProductCollection title="Shop the collection" collectionIds={product?.collections} />
        </LazyLoad>
      )}
    </>
  );
};
